import { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';
import { useParams } from 'react-router-dom';
import { RecordDetailClient } from '@/features/records/ui/record-detail-client';
import { Spinner } from '@/shared/ui';

export function RecordDetailPage() {
  const { recordId } = useParams<{ recordId: string }>();

  if (!recordId) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <p>잘못된 접근입니다.</p>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>기록서 상세 | 동구바이오제약</title>
      </Helmet>
      <Suspense
        fallback={
          <div className="w-full h-full flex items-center justify-center">
            <Spinner size="sm" />
          </div>
        }
      >
        <RecordDetailClient recordId={recordId} />
      </Suspense>
    </>
  );
}
